interface CsvUserRow {
  email: string;
  name: string;
  role: "viewer";
}

export interface CsvParseResult {
  users: CsvUserRow[];
  skippedRows: string[];
  error: string | null;
}

/**
 * Parse a CSV string into user import rows.
 *
 * Expected columns (case-insensitive): email, first_name, last_name.
 * Column order does not matter.
 */
// eslint-disable-next-line complexity -- SIM-1760: CSV parser branches once per validation case (header/row count/column order/email shape/etc). Each branch is a real input variant the user can produce.
export function parseCsvUsers(csvText: string): CsvParseResult {
  const lines = csvText.split(/\r?\n/).filter((line) => line.trim());

  if (lines.length < 2) {
    return {
      users: [],
      skippedRows: [],
      error: "CSV must have a header row and at least one data row.",
    };
  }

  const header = lines[0].split(",").map((h) => h.trim().toLowerCase());
  const emailIdx = header.indexOf("email");
  const firstNameIdx = header.indexOf("first_name");
  const lastNameIdx = header.indexOf("last_name");

  if (emailIdx === -1 || firstNameIdx === -1 || lastNameIdx === -1) {
    return {
      users: [],
      skippedRows: [],
      error: "CSV must have columns: email, first_name, last_name",
    };
  }

  const users: CsvUserRow[] = [];
  const skippedRows: string[] = [];

  for (let i = 1; i < lines.length; i++) {
    const cols = lines[i].split(",").map((c) => c.trim());
    const email = cols[emailIdx] || "";
    const firstName = cols[firstNameIdx] || "";
    const lastName = cols[lastNameIdx] || "";

    if (!email || !firstName || !lastName) {
      skippedRows.push(`Row ${i + 1}: Skipped (missing required fields)`);
      continue;
    }

    users.push({ email, name: `${firstName} ${lastName}`, role: "viewer" });
  }

  return { users, skippedRows, error: null };
}
